import { appConfig } from '@/shared/legacy/lib/config/app-config';
import { elixirConfig } from '@/shared/legacy/lib/config/elixir-config';
import { userPermissions } from '@/shared/legacy/lib/config/user-permissions';
import tariffs from '@/shared/lib/tariffs';
import { DateTimeHelper } from '@/shared/legacy/lib/util/date-time-helper';
import { StorageHelper } from '@/shared/legacy/lib/util/storage-helper';
import { trlMessage } from '@/shared/lib/i18n';

let instance = null;

export default function getOrCreateElixirInstance() {
  const accountName = appConfig.get('account')?.name ?? '';
  const ElixirChatWidget = window.ElixirChatWidget;
  const elixir = elixirConfig.config;
  const ELIXIR_DEFAULT_CONFIG = {
    apiUrl: elixir?.apiUrl,
    socketUrl: elixir?.socketUrl,
    backendStaticUrl: elixir?.backendStaticUrl,
    companyId: elixir?.company_id
  };
  const region = (appConfig.get('instanceRegion') || '').toLocaleUpperCase();
  const defaultRegion = (appConfig.get('defaultRegion') || '').toLocaleUpperCase();
  const shouldShowRegion = region && region !== defaultRegion;
  const title = shouldShowRegion
    ? `[${region}] ${userPermissions.get('name')}`
    : userPermissions.get('name');

  const access = tariffs.licenseInfo?.current_license ? 'ACTIVE' : 'BLOCKED';
  const isElixirEnabled = Boolean(elixir);
  if (isElixirEnabled === false) {
    return undefined;
  }
  if (instance) {
    return instance;
  }
  const room = {
    id: elixir?.room_id,
    title,
    data: {
      version: appConfig.get('version'),
      // wtf ?. не работает и отъебывает :(
      plan: tariffs.licenseInfo?.current_license
        ? tariffs.licenseInfo?.current_license?.tariff_group?.name
        : 'NONE',
      planInfo: getDateString() || '',
      access
    }
  };
  const client = {
    id: elixir?.client_id,
    fullName: accountName,
    locale: appConfig.get('lang').split('_')[0]
    // firstName: accountName.split(/\s+/)[0],
    // lastName: accountName.split(/\s+/)[1] || ''
  };
  StorageHelper.setJSON('elixirchat-config', elixir);
  instance = new ElixirChatWidget({
    ...ELIXIR_DEFAULT_CONFIG,
    room,
    client
  });

  const customEmployerName = (sender) => {
    const defaultTitle = trlMessage('elixir_title');
    if (sender.isOperator) {
      // eslint-disable-next-line no-restricted-syntax
      const name = trlMessage(`elixir.employee.${sender.id}`, '', defaultTitle);
      if (name === defaultTitle) {
        return name;
      }
      return name + trlMessage('from.huntflow');
    }
    return defaultTitle;
  };

  instance.appendWidget({
    title: trlMessage('elixir_title'),
    container: createElixirMountPoint(),
    hideDefaultButton: true,
    supportEmail: appConfig.get('supportEmail'),
    chatSubtitle: 'Ответим в течение нескольких минут',
    enabledChannels: ['whatsapp', 'telegram', 'facebook', 'vkontakte', 'viber'],
    customEmployerName,
    fonts: [
      {
        fontFamily: 'Graphik',
        fontWeight: 500
      }
    ],

    iframeCSS: `
      @font-face {
        font-family: 'Graphik';
        src: url('${window.STATIC_URI}fonts/graphik-400.woff2') format('woff2');
        font-weight: 400;
        font-style: normal;
      }
      @font-face {
        font-family: 'Graphik';
        src: url('${window.STATIC_URI}fonts/graphik-500.woff2') format('woff2');
        font-weight: 500;
        font-style: normal;
      }
      body, input, button, textarea {
        font-family: Graphik, "Helvetica Neue", sans-serif !important;
        font-size: 14px;
        line-height: 20px;
        color: #050505;
        font-weight: 400;
      }
      b {
        font-weight: 500;
      }
      .elixirchat-chat-messages__item--by-operator .elixirchat-chat-messages__sender,
      .elixirchat-chat-messages__item--by-another-client .elixirchat-chat-messages__sender {
        color: #22BBD2 !important; /* turquoise */
      }
      .elixirchat-welcome-screen__chat-button {
        background: #22BBD2 !important; /* turquoise */
      }
      .elixirchat-chat-messages__item--by-me .elixirchat-chat-messages__balloon {
        background: #5951BE !important; /* purple */
        padding: 8px 12px 8px 12px;
      }
      .elixirchat-chat-messages__take-screenshot {
        padding: 8px 12px 8px 12px;
        height: auto;
        line-height: 20px;
      }
      .elixirchat-chat-header,
      .elixirchat-chat-messages__date-title,
      .elixirchat-chat-messages__sender,
      .elixirchat-chat-typing {
        font-weight: 500;
        text-transform: none;
      }
      .elixirchat-chat-messages__date-title {
        border-bottom: 1px solid #050505;
        font-size: 14px;
        line-height: 20px;
      }
      .elixirchat-chat-avatar__system {
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='28' height='28' fill='none' viewBox='0 0 28 28'%3E%3Cg clip-path='url(%23a)'%3E%3Cg clip-path='url(%23b)'%3E%3Cpath fill='%23f5f5f5' d='M0 14C0 6.268 6.268 0 14 0s14 6.268 14 14-6.268 14-14 14S0 21.732 0 14'/%3E%3Cpath fill='%2325cfe8' d='M14 0C6.268 0 0 6.14 0 13.714v.561c0 7.574 6.268 13.714 14 13.714s14-6.14 14-13.714v-.561C28 6.14 21.732 0 14 0'/%3E%3Cpath fill='%23fff' d='M20.972 6.893h-3.146l-3.613 5.194h-.365l-3.43-5.194H7.15l4.729 7.02-5.115 7.183h3.228l3.775-5.214h.365l3.734 5.214h3.37l-5.115-7.244z'/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='a'%3E%3Cpath fill='%23fff' d='M0 0h28v28H0z'/%3E%3C/clipPath%3E%3CclipPath id='b'%3E%3Cpath fill='%23fff' d='M0 14C0 6.268 6.268 0 14 0s14 6.268 14 14-6.268 14-14 14S0 21.732 0 14'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E")!important;
      }
      .elixirchat-chat-messages__item--by-client b {
        color: #5951BE !important;
      }
    `

    /* iframeStyles: `
            @font-face {
                font-family: 'Raleway';
                src: url('${window.STATIC_URI}/fonts/raleway-regular-text-figures-webfont.woff2') format('woff2'),
                    url('${window.STATIC_URI}/fonts/raleway-regular-text-figures-webfont.woff') format('woff');
                font-weight: normal;
                font-style: normal;
            }

            @font-face {
                font-family: 'Raleway';
                src: url('${window.STATIC_URI}/fonts/raleway-bold-webfont.woff2') format('woff2'),
                    url('${window.STATIC_URI}/fonts/raleway-bold-webfont.woff') format('woff');
                font-weight: 500;
                font-style: normal;
            }

            body,
            input,
            button,
            textarea {
                font: 14px/18px "Raleway" !important;
            }
            .elixirchat-chat-header,
            .elixirchat-chat-messages__date-title,
            .elixirchat-chat-messages__sender,
            .elixirchat-chat-typing {
                font-family: "Raleway" !important;
                font-weight: 500 !important;
            }
            .elixirchat-chat-messages__sender {
                color: #5951BD !important;
            }
            .elixirchat-chat-messages__item--by-me .elixirchat-chat-messages__balloon {
                background-color: #5951BD !important;
            }
            .elixirchat-chat-messages__reply-button:hover,
            .elixirchat-chat-messages__item--by-operator .elixirchat-chat-messages__sender {
                color: #22BBD2 !important;
            }
            .elixirchat-chat-messages__take-screenshot {
                background-color: #22BBD2 !important;
            }
            .elixirchat-chat-messages__take-screenshot:hover {
                background-color: #1ea6ba !important;
            }

            .elixirchat-chat-messages__sender * {
                font-weight: normal;
            }

            .elixirchat-chat-messages__text b {
                font-family: "Raleway" !important;
                font-weight: 500 !important;
            }
        ` */
  });
  return instance;
}

function createElixirMountPoint() {
  const mountPoint = document.createElement('div');
  mountPoint.style.cssText = `
        height: 0px !important;
        width: 0px !important;
        position: fixed !important;
        top: 0px !important;
        left: 0px !important;
        z-index: 999999 !important;
    `;
  document.body.appendChild(mountPoint);
  return mountPoint;
}

function getTariffsDate(currentLicense) {
  if (currentLicense) {
    const tariffName = currentLicense.tariff_group?.name;
    const tariffEnd = DateTimeHelper.toShortFormat({
      date: currentLicense.scheduled_end_at
    });
    const tariffStart = DateTimeHelper.toShortFormat({
      date: currentLicense.scheduled_begin_at
    });
    const currentTariff = `${tariffName}\n${tariffStart} — ${tariffEnd}`;
    return currentTariff;
  }
  return '';
}
function getDateString() {
  if (tariffs.licenseInfo) {
    return `${
      tariffs.licenseInfo?.current_license
        ? ''
        : `${getTariffsDate(tariffs.licenseInfo?.previous_license)}`
    }${getTariffsDate(tariffs.licenseInfo?.current_license)}${
      tariffs.licenseInfo?.next_license
        ? `\n\n${getTariffsDate(tariffs.licenseInfo?.next_license)}`
        : ''
    }`;
  }
}
